import { render, staticRenderFns } from "./AlarmLightComponent.vue?vue&type=template&id=1bf8c468&scoped=true&"
var script = {}
import style0 from "./AlarmLightComponent.vue?vue&type=style&index=0&id=1bf8c468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8c468",
  null
  
)

export default component.exports